import useShipmentsPaginated from 'hooks/useShipmentsPaginated';
import { SHIPMENT_COLUMN_STATUS_ID } from 'types/orders';

interface UseShipmentColumnDataOptions {
  statusId: SHIPMENT_COLUMN_STATUS_ID;
  queryParams?: string;
  enabled?: boolean;
}

/**
 * Hook para manejar la carga y paginación de shipments por status.
 * Wrapper sobre useShipmentsPaginated para las columnas del tablero de operaciones.
 * @param options - Opciones de configuración del hook
 * @returns Objeto con datos agrupados, estados de carga y funciones de control
 */
const useShipmentColumnData = ({
  statusId,
  queryParams = '',
  enabled = true
}: UseShipmentColumnDataOptions) => {
  return useShipmentsPaginated({
    statusId,
    swrKeyPrefix: 'shipments-by-status',
    queryParams,
    enabled
  });
};

export default useShipmentColumnData;
